import SelectCard from "./SelectCard";
import React, { useState } from "react";

const Cards = ({
    page,
    aplicaciones,
    NavigationControl,
}) => {

    const [currentActive, setCurrentActive] = useState({
        id: null
    });

    return (
        <div className="cards__view">
            <div>
                {
                    page.map((item, index) => {
                        return <SelectCard
                            key={index}
                            infoCard={item}
                            aplicaciones={aplicaciones}
                            index={index}
                            currentActive={currentActive}
                            setCurrentActive={setCurrentActive}
                        />
                    })
                }
            </div>
            <div className={"cards__navigation"}>
                <NavigationControl />
            </div>
        </div>
    );
}

export default Cards;